import SmoothScroll from 'smooth-scroll'

export default () => {
  return React.useMemo(() => new SmoothScroll(), [])
}
